import React from "react";

function MinFaq() {
  return (
    <div className="bg-white bg-white rounded-lg shadow">
      <div className="max-w-screen-xl mx-auto pb-16 sm:pt-16 sm:pb-20 px-4 sm:px-6 lg:pb-28 lg:px-8">
        <h2 className="text-3xl leading-9 font-extrabold text-gray-900">
          FAQs
        </h2>
        <div className="mt-6 border-t-2 border-gray-100 pt-8">
            <div className="md:grid md:grid-cols-2 md:gap-8">
              <dl className="md:m-0">
                <dt className="text-lg leading-6 font-medium text-gray-900">
                  Can I have different taxation / accounting codes for onetime
                  charges?
                </dt>
                <dd className="mt-2">
                  <p className="text-base leading-6 text-gray-700">
                    OneBill allows to define taxcode and accounting (GL) Code
                    for every charge defined in the system. So every onetime
                    charge can have their own tax codes as well as accounting
                    codes
                  </p>
                </dd>
              </dl>
              <dl className="md:m-0 sm:mt-12">
                <dt className="text-lg leading-6 font-medium text-gray-900">
                  Does OneBill prorate charges if a recurring subscription is
                  cancelled?
                </dt>
                <dd className="mt-2">
                  <p className="text-base leading-6 text-gray-700">
                    OneBill would prorate and provide a credit of charge if a
                    subscription is cancelled. This would again depend on the
                    proration flag defined at charge definition which is
                    selected by default.
                  </p>
                </dd>
              </dl>
              <dl className="md:m-0 sm:mt-12">
                <dt className="text-lg leading-6 font-medium text-gray-900">
                  Why am I not able to modify the charge of the plan when
                  placing an order?
                </dt>
                <dd className="mt-2">
                  <p className="text-base leading-6 text-gray-700">
                    Please check if the plan for which you are processing the
                    order for has the 'Allow Price Overrife' checkbox enabled
                    for it.
                  </p>
                </dd>
              </dl>
              <dl className="md:m-0 sm:mt-12">
                <dt className="text-lg leading-6 font-medium text-gray-900">
                  When should I set the Override price in my priceplan?
                </dt>
                <dd className="mt-2">
                  <p className="text-base leading-6 text-gray-700">
                    OneBill provides the override plan option for businesses
                    which sell the same priceplan at different prices to
                    different subscribers or subscriptions. OneBill provides the
                    override option to sell the same plan at different
                    pricepoints for different purchases.
                  </p>
                </dd>
              </dl>
              <dl className="md:m-0 sm:mt-12">
                <dt className="text-lg leading-6 font-medium text-gray-900">
                  Does OneBill prorate charges when a plan with recurring charge
                  is changed?
                </dt>
                <dd className="mt-2">
                  <p className="text-base leading-6 text-gray-700">
                    OneBill would prorate and provide a credit of charge for
                    existing priceplan and apply a prorated charge for the new
                    plan when the plan for existing subscription is changed. The
                    resulting net charges could be positive or negative
                    depending on the plan change being an upgrade or downgrade.
                  </p>
                </dd>
              </dl>
              <dl className="md:m-0 sm:mt-12">
                <dt className="text-lg leading-6 font-medium text-gray-900">
                  Where can I find the Integrator key for configuring the
                  <a
                    href="http://onebillknowledgehub.helpdocsonline.com/e-sign"
                    target="_blank"
                    rel="noopener"
                    className="text-indigo-700 inline-block px-2 "
                  >
                    DocuSign
                  </a>
                  Integration?
                </dt>
                <dd className="mt-2">
                  <p className="text-base leading-6 text-gray-700">
                    He couldn't see himself doing it. Lorem ipsum dolor sit amet
                    consectetur adipisicing elit. Quas cupiditate laboriosam
                    fugiat.
                  </p>
                </dd>
              </dl>
            </div>
        </div>
      </div>
    </div>
  );
}

export default MinFaq;
